import './About.css';
import { useState } from 'react';
import tina from "../../../media/Textures/tina.png";
import daisy from "../../../media/Textures/Dogs/daisy.png";

function About() {
  const [viewResume, setViewResume] = useState(false);

  return (
    <section className="About">
      {viewResume ?
        <div className="resume-content">
          <iframe src="https://docs.google.com/document/d/e/2PACX-1vR6TaedaQHuGXvYs8yMslXQj6GLAjtiTNLF2W0txdd2DzVBofty0LCZt3sqYAvdF1R9Gjj8loBBefxi/pub?embedded=true" scrolling='no'></iframe>
          <div className="resume-buttons">
            <button className="download-button" onClick={() => window.open('https://docs.google.com/document/d/1-OS9kFF7UIVy87S7pZAdzoYShRUvGlyuOU_MT4PXNoo/export?format=pdf', '_blank')}>
              Download
            </button>
            <button className="resume-toggle" onClick={() => setViewResume(false)}>Return</button>
          </div>
        </div> :
        <div className="about-content">
          <div className="about-img-container">
            <img src={tina} alt="Christina Verton" className="profile-pic" />
            <button className="resume-toggle" onClick={() => setViewResume(true)}>Resume</button>
          </div>
          <div className="about-text-container">
            <div className="about-text-container-main">
              <h1>HI!</h1>
              <p>
                My name is Christina, I am a 2026 graduate from the animation program at Algonquin college.<br /><br />

                Born and raised in Ottawa, Ontario, I spent most of my time growing up drawing whatever I found funny. My love for animation started from watching the pokemon movies as a kid, my favorites were: Pokemon : the Rise of Darkrai and Pokemon : The Jewel of Life.<br /><br />

                I spend my summers working at/with various art camps and filled with young artists who burn with more passion then you'll ever see. Working with these young artists has really inspired me to push harder and to strive as much as possible in animation.<br /><br />

                I hope to hear from you soon!
              </p>
            </div>
            <div className="about-text-container-footer">
              <img src={daisy} alt="Daisy" className="daisy-about" />
            </div>
          </div>
        </div>}
    </section>
  );
}

export default About;
